import { render } from "./StockLocationDialog.vue?vue&type=template&id=10d74c38&scoped=true"
import script from "./StockLocationDialog.vue?vue&type=script&lang=js"
export * from "./StockLocationDialog.vue?vue&type=script&lang=js"

import "./StockLocationDialog.vue?vue&type=style&index=0&id=10d74c38&scoped=true&lang=css"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d74c38"]])

export default __exports__